import React, { useState } from 'react';
import logoImg from '../../images/Logo.jpeg';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = (sectionId) => {
    setIsMenuOpen(false);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-top">
        <div className="container">
          <div className="header-contact">
            <span><i className="fas fa-phone-alt" style={{ marginRight: '0.5rem' }}></i>+91 96256 53930</span>
            <span><i className="fas fa-envelope" style={{ marginRight: '0.5rem' }}></i>oyatriletsgo@gmail.com</span>
            {/* <a
              href="https://wa.me/919625653930"
              target="_blank"
              rel="noopener noreferrer"
              className="header-whatsapp-icon"
              aria-label="Chat on WhatsApp"
            >
              <i className="fab fa-whatsapp"></i>
            </a> */}
          </div>
        </div>
      </div>
      
      <div className="header-main">
        <div className="container">
          <div className="header-content">
            <button className="logo" onClick={scrollToTop} style={{ background: 'none', border: 'none', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <img src={logoImg} alt="OYATRI Logo" style={{ height: '2.5rem', width: '2.5rem', objectFit: 'contain', borderRadius: '0.5rem' }} />
              <h1 style={{ margin: 0 }}>OYATRI</h1>
            </button>

            <button className="menu-toggle" onClick={toggleMenu}>
              <span></span>
              <span></span>
              <span></span>
            </button>

            <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
              <ul>
                <li><button onClick={scrollToTop} className="nav-link">Home</button></li>
                <li><button onClick={() => handleNavClick('popular-tours')} className="nav-link">Holidays</button></li>
                <li><button onClick={() => handleNavClick('about-section')} className="nav-link">About Us</button></li>
                <li><button onClick={() => handleNavClick('contact-section')} className="nav-link">Contact</button></li>
                <li><button onClick={() => handleNavClick('info-section')} className="nav-link">Information</button></li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
